import React from 'react';

export class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = {hasError: false};
    }

    static getDerivedStateFromError() {
        return {hasError: true};
    }

    render() {
        if (this.state.hasError) {
            return (
                <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    minHeight: '50vh',
                    padding: '20px'
                }}>
                    <h2>Възникна неочаквана грешка</h2>
                    <p>Моля, опитайте отново.</p>
                    <button
                        className="btn btn-primary mt-3"
                        onClick={() => window.location.reload()}
                    >
                        Презареди страницата
                    </button>
                </div>
            );
        }

        return this.props.children;
    }
}
